import { motion, AnimatePresence } from 'framer-motion'
import * as css from './styles'
import { importStatus } from './types'
import { t } from '@lingui/core/macro'

export const UploadMessage = ({ keyName, children }) => (
  <AnimatePresence key={`animate-${keyName}`}>
    <motion.div style={{ position: 'relative' }}>
      <motion.div
        key={keyName}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '5px' }}
      >
        {children}
      </motion.div>
    </motion.div>
  </AnimatePresence>
)

const UploadMessageTitle = ({ children }) => <css.Title>{children}</css.Title>

const UploadMessageDescription = ({ children }) => <css.Description>{children}</css.Description>

const UploadMessageStatus = ({ status }) => (
  <css.Status>
    {t`Current status:`}
    {status === importStatus.IN_PROGRESS ? (
      <span className="-in-progress">{t`In progress`}</span>
    ) : status === importStatus.FAILED ? (
      <span className="-is-error">{t`Failed`}</span>
    ) : null}
  </css.Status>
)

UploadMessage.Title = UploadMessageTitle
UploadMessage.Description = UploadMessageDescription
UploadMessage.Status = UploadMessageStatus
